import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { NavLink } from 'react-router'
import { useAppSelector } from 'universal-scripts'
import { navItems, type NavItem } from './nav.config'
import { useUserAcl } from '@hooks/useUserAcl'

import './Nav.css'

export default function Nav() {
  const intl = useIntl()
  const acl = useUserAcl()
  const isSidebarOpen = useAppSelector((state) => state.ui.isSidebarOpen)
  const isBetatester = acl.includes('betatester')

  const visibleItems = useMemo(
    () => navItems.filter((item) => !item.betaOnly || isBetatester),
    [isBetatester]
  )

  return (
    <nav id="main-nav" className={isSidebarOpen ? 'nav-extended' : ''}>
      <ul>
        {visibleItems.map((item: NavItem) => {
          const title = intl.formatMessage({ id: item.titleId })
          return (
            <li key={item.path}>
              <NavLink
                title={title}
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) =>
                  `nav-link${isActive ? ' active' : ''}`
                }
              >
                <span className={`icon icon-${item.icon}`} />
                <strong>{title}</strong>
              </NavLink>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
